module.exports = __webpack_public_path__ + "static/img/img_shop_cabinet.5a4ac49f.png";